<template>
  <vs-popup class="holamundo" :active="isActive" :buttons-hidden="true">
    <div class="export-popup-parent">
      <h3 class="export-headline">Export</h3>

      <label class="export-labels" for="">File Name</label>
      <div class="export-pop-up-input-parent">
        <input id="export-popup-file-name-input" v-model="form.filename" name="form.filename" class="export-pop-up-input w-full" :class="{'has-error': errors.has('form.filename')}" :placeholder="$t('Type your file name')" maxLength="25" type="text">
      </div>
      <!-- <vs-input v-model="form.filename" name="form.filename" class="w-full" :danger="errors.has('form.filename')" :placeholder="$t('Type your file name')" maxLength="25" /> -->
      <span class="mt-1 text-danger text-sm block" v-show="errors.has('form.filename')">{{ errors.first("form.filename") }}</span>

      <br>

      <label class="export-labels" for="">Extension</label>
      <div class="export-popup-extension">
        <v-select id="export-popup-extension-list" name="form.extension" v-model="form.extension" :options="options" :placeholder="$t('Select Extension')" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <span class="text-danger text-sm block" v-show="errors.has('form.extension')">{{ errors.first("form.extension") }}</span>

      <div class="flex flex-wrap mt-10 md:justify-end">
        <button v-on:click="$emit('click')" id="export-pop-up-export-button" class="export-pop-up-main-button md:order-last md:ml-4" @click="exportData"> {{ $t('Export') }} </button>
        <button id="export-pop-up-cancel-button" class="export-pop-up-cancel-button" type="border" text-color="#2C2C2C" @click="cancel"> {{ $t('Cancel') }} </button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return ['CSV', 'XLSX']
      }
    },
    isActive: {
      type: Boolean,
      default: false
    },
    exportType: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    fileName: {
      type: String
    }, 
    columns: {
      type: Array
    }
  },
  data () {
    return {
      form: {
        filename: this.fileName || '',
        extension: 'CSV'
      }
    }
  },
  methods: {
    cancel () {
      // reset the form
      this.form.extension = 'CSV'

      this.errors.clear()

      this.$emit('hide')
    },
    async exportData () {
      try {
        const form = {
          filename: this.form.filename,
          extension: this.form.extension.toLowerCase()
        }

        const response = await window.axios.post('/export', {
          form,
          export_type: this.exportType,
          params: this.params,
          columns: this.columns
        })

        this.cancel()

        this.$root.$emit('speakol-export:started', response.data.payload.export_log_id)
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    }
  }
}
</script>

<style lang="scss">
  /deep/ .con-vs-popup /deep/ .vs-popup--content {
    padding: 51px 51px 51px 56px;
  }

  /deep/ .con-vs-popup /deep/ .vs-popup {
    border-radius: 16px !important;
  }

  .export-headline {
    margin-bottom: 27px;
    font-weight: 500;
    font-size: 24px;
  }

  .export-labels {
    font-weight: normal;
    font-size: 14px;
  }

  .export-pop-up-input-parent {
    ::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .export-pop-up-input {
    height: 40px;
    text-indent: 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    margin-top: 6px;
  }

  .export-popup-extension {
    .vs__dropdown-toggle {
      border: 1px solid rgba(0, 0, 0, 0.15) !important;
      height: 40px;
      margin-top: 6px;
    }

    .v-select .vs__dropdown-toggle .vs__actions .vs__clear,
    .vs__open-indicator {
      color: #999 !important;
    }
  }

  .export-pop-up-main-button {
    background: #0092d7;
    color: white;
    border: none;
    outline: none;
    box-shadow: none;
    border-radius: 3px;
    height: 48px;
    width: 185px !important;
    cursor: pointer;
  }

  .export-pop-up-cancel-button {
    background: #fff;
    color: rgba(0, 0, 0, 0.65);
    border: 2px solid #d9d9d9;
    outline: none;
    box-shadow: none;
    border-radius: 3px;
    height: 48px;
    width: 135px !important;
    cursor: pointer;
  }

  .has-error {
    border: 1px solid red;
  }

  @media (max-width: 576px) {
    .export-pop-up-main-button,
    .export-pop-up-cancel-button {
      width: 100% !important;
    }

    .export-pop-up-main-button {
      margin-bottom: 16px;
    }

    /deep/ .con-vs-popup /deep/ .vs-popup--content {
      padding: 24px 21px 24px 24px;
    }
  }
</style>
